export const locale = "de-DE";

export const tokens = {
	EMAIL_ADDRESS: "Email Adresse",
	PASSWORD: "Passwort",
	REMEMBER_ME: "Angemeldet bleiben",
	FORGOT_PASSWORD: "Passwort vergessen?",
	LOG_IN: "Anmelden",
	NO_ACCOUNT: "Neu bei Petdata? ",
	SIGN_UP: "Bestellen",
	OR: " oder ",
	VIEW_DEMO: "Demo starten",
	INVALID_CREDENTIALS: "Die eingegebenen Daten sind nicht korrekt.",
	PLEASE_REENTER: "Bitte versuchen Sie es erneut.",
	
	LABELS: "Etiketten",
	CARE_SHEETS: "Tierinformationsblätter",
	ADVERTISING_SPACE: "Werbefläche",
	STORE_INFO_LOGO: "Adresse und Logo",
	ARTICLE_MANAGEMENT: "Artikelverwaltung",
	USERS: "Benutzer",
	LOG_OUT: "Abmelden",
	CHANGE_STORE: "Standort/Filiale",
	
	PET_SEARCH_PLACEHOLDER: "Tiername oder PLU-Code, Beispiel: Nymphensittich bzw. Nymphicus hollandicus",
	
	CREATE_USER: "Benutzer erstellen",
	NAME: "Name",
	STATUS: "Status",
	ACTIVE: "Aktiv",
	INACTIVE: "Nicht aktiv",
	
	USER_INFO: "Benutzerinfo",
	FIRST_NAME: "Vorname",
	LAST_NAME: "Nachname",
	CONFIRM_PASSWORD: "Bitte das Passwort wiederholen",
	CANCEL: "Abbrechen",
	
	PERMISSIONS: "Berechtigungen",
	LOCATION: "Standort",
	PRINT_CARE_SHEETS: "Tierinformationsblätter",
	PRINT_LABELS: "Etiketten",
	EDIT_AD_SPACE: "Werbefläche",
	EDIT_STORE_INFO_LOGO: "Adresse und Logo",
	
	EDIT_USER: "Benutzer bearbeiten",
	CHANGE_PASSWORD: "Passwort ändern",
	SAVE: "Speichern",
	
	ADVERTISING_DETAILS: "Das Bild muss eine Größe von 57 x 128 mm bzw. 673 x 1512 Pixel @ 300 dpi haben. Folgende Formate werden unterstützt: jpg und png. Das Bild kann pro Tiertyp einzeln konfiguriert werden.",
	PET_TYPE: "Tiertyp",
	AD_UPLOADED: "Bild",
	UPLOAD: "Upload",
	CLEAR: "Löschen",
	
	STORE_INFO_DETAILS: "Auf dem Tierinformationsblatt kann das Logo oder die Adresse angezeigt werden.",
	STORE_INFO: "Adresse",
	LINE1: "1. Zeile",
	LINE2: "2. Zeile",
	LINE3: "3. Zeile",
	LINE4: "4. Zeile",
	USE_LOGO_INSTEAD: "Ich möchte mein Logo verwenden",
	UPLOAD_LOGO: "Upload Logo",
	STORE_LOGO_DETAILS: "Das Firmenlogo muss eine Größe von 57 x 45 mm bzw. 673 x 531 Pixel @ 300 dpi haben.",
	STORE_LOGO_FORMATS: "Es werden nur JPG und PNG Formate unterstützt.",
	
	PREVIEW_CARE_SHEET: "Voransicht",
	
	SEARCH_PETS: "Suche",
	SEARCH_FOR_A_PET: "Suche nach einem Tier",
	NO_RESULTS_TRY_AGAIN: "Es wurden keine Treffer gefunden. Versuchen Sie es nochmal.",
	DOWNLOAD: "Download",
	
	SAVED_SUCCESSFULLY: "Die Änderung wurde übernommen",
	
	SELECT: "Auswählen",
	
	CUSTOMIZE_COLORS_LOGO: "Design ändern",
	PAGE_SETUP: "Seite einrichten",
	GENERATE: "Erstellen",
	PLU: "PLU-Code",
	ENABLE_PLU: "PLU-Code anzeigen",
	PLU_CONFIRMATION: "Diese Änderung löscht die bereits ausgewählten Etiketten. Möchten Sie fortfahren?",
	YES: "Ja",
	NO: "Nein",
	CREATE_LABEL: "Etikett erstellen",
	CREATE_CUSTOM_LABEL: "Leeretikett erstellen",
	OR_CREATE_CUSTOM_LABEL: "oder Leeretikett erstellen",
	RESULTS: "Ergebnisse",
	BACK_SEARCH_RESULTS: "Zurück zu den Suchergebnissen",
	BACK_TO_LABELS_SEARCH_RESULTS: "Zurück zu Etiketten",
	ENTER_PRICE_SEARCH_RESULTS: "Preis",
	ENTER_PRICE: "Preis eingeben",
	ENTER_PLU: "PLU eingeben",
	EDIT_LABEL: "Etikett editieren",
	SAVE_LABEL: "Etikett speichern",
	ENTER_BARCODE: "EAN Barcode eingeben",
	ENTER_NAME: "Name eingeben",
	ENTER_LATIN_NAME: "Lat. Name eingeben",
	CUSTOM_LABEL: "Leeretikett",
	LABEL_SIZE: "Etikettenformate",
	
	DUPLICATE_ROW: "Tier duplizieren",
	CLEAR_ROW: "Tier löschen",
	ARTICLE_INSTRUCTIONS: "Hier können Sie Preis, PLU- und EAN Code sowie einen Integrationsnamen hinterlegen, die dann am Etikett angezeigt werden (Erweiterte Einstellungen). Der Integrationsname ist hilfreich, wenn ein anderer Name als der Standardname gewünscht wird oder von demselben Tier mehrere Einträge vorhanden sind. Sie können die Werte in der Tabelle direkt eingeben oder als Excel Datei herunterladen (Datei Download), bearbeiten und mit den Änderungen wieder hochladen (Datei Upload).",
	UPLOAD_FILE: "Datei Upload",
	EXPORT_TO_EXCEL: "Datei Download",

	CUSTOMIZE_LABEL: "Etiketten-Design ändern",
	MAIN: "Hauptfarben",
	BORDER: "Rahmen",
	IMAGE_BORDER: "Bildrand",
	BACKGROUND: "Hintergrund",
	LABEL: "Detailinfo",
	TEXT: "Text",
	PRICE: "Preis",
	TITLE: "Überschrift",
	DETAIL: "Detailinfo Title",
	BARCODE: "Barcode",
	RESTORE_DEFAULT_COLORS: "Standard wiederherstellen",
	LOGO: "Logo",
	LOGO_FORMAT: "202 x 118 Pixel @ 300 dpi",
	RIGHTCOLUMN: "Rechte Splate",
	
	PRINTER_ADJUSTMENT: "Seite anpassen",
	ADJUSTMENT_INSTRUCTIONS: "Um Etiketten millimetergenau zu platzieren, kann der Ausdruck vertikal und horizontal justiert werden.<p> <br /> Horizontal:<br /> Soll das Etikett z.B. um 5 mm nach rechts verschoben werden, geben Sie 5 im Feld „Horizontal (mm)“ ein. Bei der Eingabe von -5 wird das Etikett um 5 mm nach links verschoben.</p><p><br /> Vertikal:<br />Wenn das Etikett z.B. um 3 mm nach oben verschoben werden soll, geben Sie 3 im Feld „Vertikal (mm)“ ein. Mit der Eingabe von -3 wird das Etikett um 3 mm nach unten verschoben.</p><p><br /> Tipp:<br /> Falls das Etikett nicht der angegebenen Größe entspricht, deaktivieren Sie in den Druckereinstellung den Zoom, der bei einigen Druckern als Standard eingestellt ist.</p>",
	A_VERTICAL: "Vertikal(mm)",
	B_HORIZONTAL: "Horizontal(mm)",


	CUSTOM_LABEL_PET_LAT_NAME: "Paracheirodon innesi",
	CUSTOM_LABEL_PET_NAME: "Neonsalmler",
	CUSTOM_LABEL_PET_PRICE: "1,99 €",

	CUSTOM_LABEL_KEY_1: "Größe",
	CUSTOM_LABEL_VALUE_1: "4 cm",
	CUSTOM_LABEL_KEY_2: "Herkunft",
	CUSTOM_LABEL_VALUE_2: "Süßwasser",
	CUSTOM_LABEL_KEY_3: "Temp.",
	CUSTOM_LABEL_VALUE_3: "21-26 °C",
	CUSTOM_LABEL_KEY_4: "Ernährung",
	CUSTOM_LABEL_VALUE_4: "Carnivor",
	CUSTOM_LABEL_KEY_5: "Haltung",
	CUSTOM_LABEL_VALUE_5: "Gruppe",
	CUSTOM_LABEL_KEY_6: "Aquarium",
	CUSTOM_LABEL_VALUE_6: "Ab 60 cm / 54 l",

	CUSTOM_LABEL_KEY_7: "Familie",
	CUSTOM_LABEL_VALUE_7: "Characidae",
	CUSTOM_LABEL_KEY_8: "Verbreitung",
	CUSTOM_LABEL_VALUE_8: "Südamerika",
	CUSTOM_LABEL_KEY_9: "Lebensraum",
	CUSTOM_LABEL_VALUE_9: "Süßwasser",
	CUSTOM_LABEL_KEY_10: "Temperatur",
	CUSTOM_LABEL_VALUE_10: "21-26 °C",
	CUSTOM_LABEL_KEY_11: "pH-Wert",
	CUSTOM_LABEL_VALUE_11: "5,5-7,5",
	CUSTOM_LABEL_KEY_12: "Härte",
	CUSTOM_LABEL_VALUE_12: "< 15 °dH",
	CUSTOM_LABEL_KEY_13: "Lebenserwartung",
	CUSTOM_LABEL_VALUE_13: "5 Jahre",
	CUSTOM_LABEL_KEY_14: "Verhalten",
	CUSTOM_LABEL_VALUE_14: "Friedlich",
	CUSTOM_LABEL_KEY_15: "Verhalten",
	CUSTOM_LABEL_VALUE_15: "Friedlich",
	CUSTOM_LABEL_KEY_16: "Fortpflanzung",
	CUSTOM_LABEL_VALUE_16: "Freilaicher",
	CUSTOM_LABEL_KEY_17: "Schwierigkeitsgrad",
	CUSTOM_LABEL_VALUE_17: "Anfänger",
	CUSTOM_LABEL_KEY_18: "Zucht",
	CUSTOM_LABEL_VALUE_18: "Mittelschwer",
	CUSTOM_LABEL_KEY_19: "Artenschutz",
	CUSTOM_LABEL_VALUE_19: "Nein",

	PAGE_NOT_FOUND: "404 Seite nicht gefunden",
	GO_BACK_TO_HOMEPAGE: "Zurück zur Startseite",

	PLEASE_ENTER_FIRST_NAME: "Vorname darf nicht leer sein.",
	PLEASE_ENTER_LAST_NAME: "Nachname darf nicht leer sein.",
	PLEASE_ENTER_VALID_EMAIL: "Bitte geben Sie eine gültige E-Mail Adresse an.",
	PASSWORD_CHARACTERS: "Vergeben Sie mind. 8 Zeichen.",
	PASSWORDS_DO_NOT_MATCH: "Passwort stimmt nicht überein.",

	EDIT: "Editieren",
	NEW_PASSWORD: "Neues Passwort",

	ACCESS_WELCOME: "Willkomen bei Petdata",

	PRINT_CALIBRATION_PAGE: "Justierungsseite erstellen",

	PREVIEW: "Voransicht",
	CURRENT_PASSWORD: "Aktuelles Passwort",
	SEND_PASSWORD: "Passwort zurücksetzten",


	RESET_PASSWORD_HEADER:"Bitte geben Sie Ihre E-Mail Adresse an.",
	RESET_PASSWORD_BACK:"Zurück zum Login",
	RESET_PASSWORD_CONFIRMATION:"Ein neues Passwort wurde an die Ihre E-Mail Adresse versendet.",

	APPLICATION_ERROR: "Fehler",
	ERROR_MESSAGE: "Ein Anwendungsfehler ist aufgetreten.",

	

	LABEL_ADDED: "Etikett erstellt",
	LABEL_ADDED_MESSAGE: "Das Etikett wurde erfolgreich erstellt!",
	CONTINUE: "Weiter",

	ADD: "Erstellen",
	MANAGEMENT: "Abo verwalten",

	DEMO_DE_LOGIN:"Deutsche Demo",
	DEMO_EN_LOGIN:"English Demo",
	DEMO_TEXT:"Sie können Petdata mit unserer Demoversion ausführlich testen. Alle Funktionen sind verfügbar, ausgenommen Editieren der Etiketten und Benutzerverwaltung.",
	DEMO_TITLE:"Demoversion starten",

	ADVANCED_SETTINGS_LINK:"Erweiterte Einstellungen",
	ADVANCED_SETTINGS_LABEL_PAGE_TITLE:"Erweiterte Einstellungen",
	ADVANCED_SETTINGS_LABEL_PAGE_DESCRIPTION:"Hier können Sie bla bla bla",
	ADVANCED_SETTINGS_LABEL_PLU_TITLE:"PLU Code",
	ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION:"Petdata Etiketten können auf den Etiketten einen PLU Code anzeigen. Diese Funktion ist standardmäßig aktiviert.",
	ADVANCED_SETTINGS_LABEL_PLU_FIELD:"PLU Code verwenden",
	ADVANCED_SETTINGS_LABEL_HEADER_TITLE:"Etiketten Titel",
	ADVANCED_SETTINGS_LABEL_HEADER_FIELD:"Reihenfolge",
	ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION:"Auf jedem Etikett stehen zwei Zeilen für den Namen des Tieres zur Verfügung. Die Belegung dieser zwei Zeilen lässt sich konfigurieren.",
	ADVANCED_SETTINGS_LABEL_METRIC_TITLE:"Maßeinheiten",
	ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION:"Tierinformationen stehen in zwei verschiedenen Maßsystemen zur Verfügung. ",
	ADVANCED_SETTINGS_LABEL_METRIC_FIELD:"Maßeinheit",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE:"Seitenformat",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION:"Petdata unterstützt das A4 und Letter Format für die PDF Erstellung.",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD:"Format",
	ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE:"Drucker justieren",

	ADVANCED_SETTINGS_LABEL_HEADER_N_LAT:"Zeile 1: Name; Zeile 2: Wissenschaftlicher Name",
	ADVANCED_SETTINGS_LABEL_HEADER_LAT_N:"Zeile 1: Wissenschaftlicher Name; Zeile 2: Name",
	ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT:"Zeile 1 Integrationsname aus der Artikelverwaltung falls vorhanden, sonst Name; Zeile 2: Wissenschaftlicher Name",

	ADVANCED_SETTINGS_LABEL_METRIC_US:"Angloamerikanisches Maßsystem (pound, inch, )",
	ADVANCED_SETTINGS_LABEL_METRIC_EU:"Metrisches Maßsystem (Gramm, Zentimeter, ...)",

	
};


/** WEBPACK FOOTER **
 ** ./src/translations/de-DE.js
 **/